<ng-container *ngIf="sponsor">
  <a
    class="inline-block"
    href="{{ sponsor.url }}"
    target="_blank"
  >
    <img
      alt="{{ sponsor.name }} logo"
      class="aspect-square object-contain"
      src="{{ sponsor.logoURL }}"
      height="180"
      width="180"
    />
  </a>
</ng-container>
